import { SuperLedgerStatus } from "../types/enum";
import { isObservableArray } from "mobx";

export const LEDGER_STATUS_NAMES = ["Pending", "Paid", "Posted", "Processing", "Refunded", "Failed"];

export function ledgerStatusName(value) {
    const match = LEDGER_STATUS_NAMES.find(name =>
        value === SuperLedgerStatus[name].ordinal ||
        (typeof value === "string" && (
            value.trim() === String(SuperLedgerStatus[name].ordinal) ||
            value.trim().toLowerCase() === name.toLowerCase()
        ))
    );
    return match || "Unknown";
}

export function summarizeLedgerGroup(group = {}) {
    group = group || {};
    const items = Array.isArray(group.items) || isObservableArray(group.items) ? group.items : [];
    // Read live entries rather than a group snapshot that can outlive filters/payments.
    if (items.length) {
        const counts = {};
        Array.from(items).forEach(item => {
            const name = ledgerStatusName(item && item.status);
            counts[name] = (counts[name] || 0) + 1;
        });
        return {
            counts,
            total: items.length,
            paid: counts.Paid || 0,
            fullyPaid: counts.Paid === items.length,
            reportedOnly: false
        };
    }
    // A unique status list provides neither counts nor proof every entry is settled.
    const statuses = Array.isArray(group.statuses) || isObservableArray(group.statuses) ? group.statuses : [];
    const counts = {};
    statuses.forEach(status => { counts[ledgerStatusName(status)] = null; });
    return { counts, total: null, paid: null, fullyPaid: false, reportedOnly: true };
}
